export default "__VITE_ASSET__BPiGJ2Nm__"